<template lang="pug">
  b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
    b-card
      b-row.mb-3
        b-col
          b-form-group
            b-form-input(placeholder="Nombre de enlace", v-model="document.name", @input="updateDebounce" )
          b-form-group
            b-form-input(placeholder="Descripción", v-model="document.description", @input="updateDebounce")
          b-form-row.align-items-center
            b-col
              b-form-group
                b-form-input.text-primary(placeholder="URL del sitio", v-model="document.link", @input="updateDebounce")
            b-col(cols="auto")
              info-icon.icon-md.hover-primary.pointer.text-secondary(v-b-tooltip="'Acepta enlaces a sitios estáticos, como una página web o landing page.'")
        b-col(cols="auto")
          trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy")
      b-row
        b-col
          div Elementos HTML
          .text-secondary.text-sm
            div Por default, se extraerán los títulos y párrafos del sitio
            div ( h1, h2, h3, span y p).
        b-col(cols="auto")
          b-button.mr-2(variant="an", size="sm", :disabled="loading", @click="showNewElement = true") Agregar elemento
      small.text-secondary.mb-3 Si necesitas información más precisa, puedes incluir elementos HTML específicos.
      transition(name="fade")
        b-card(v-if="showNewElement")
          b-form-row.mb-2
            b-col(md="6")
              b-form-group(label="Tag", label-size="sm", label-cols="auto")
                b-form-input(placeholder="Etiqueta", size="sm", v-model="newElement.tag" )
            b-col(md="6")
              b-form-group(label="Id", label-size="sm", label-cols="auto")
                b-form-input(placeholder="#Identificador", size="sm", v-model="newElement.attributes.id" )
            b-col
              b-form-group(label="Clases", label-size="sm" )
                b-form-tags(v-model="newElement.attributes.css", placeholder="Agregar clases", size="sm",  add-button-text="Agregar", duplicate-tag-text="Valores duplicados" )
          .text-right
            b-button.mr-2(variant="secondary", size="sm", @click="showNewElement = false") Cancelar
            b-button.mr-2(variant="an", size="sm", :disabled="loading || !newElement.tag", @click="createElement") Agregar
      b-card(v-for="(element, index) in document.elements", :key="index", bg-variant="soft-primary" )
        b-form-row
          b-col(md="6")
            b-form-group(label="Tag", label-size="sm", label-cols="auto")
              b-form-input(placeholder="Etiqueta", size="sm", v-model="element.tag")
          b-col(md="6")
            b-form-group(v-if="element.attributes", label="Id", label-size="sm", label-cols="auto")
              b-form-input(placeholder="#Identificador", size="sm", v-model="element.attributes.id" )
          b-col
            b-form-group(label="Clases", label-size="sm" )
              b-form-tags(:value="element.attributes && element.attributes.css ? element.attributes.css.split(',') : []",
                @input="element.attributes.css = $event.join()"
                placeholder="Agregar clases",
                size="sm",
                add-button-text="Agregar",
                duplicate-tag-text="Valores duplicados",
              )
      b-row.justify-content-center.mb-3
        b-col(md="10")
          b-button(variant="an", block, :disabled="loading", @click="updateDocument") Generar conocimiento
      .mb-2 Contenido
      b-card.mb-1(v-for="node in document.nodes", :key="node.id" )
        b-form-group
          template(#label)
            .text-right
              trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="destroyNode(node.id)")
          b-form-textarea(rows="4", v-model="node.text", @input="updateNode(node)")
</template>

<script>
import { mapActions } from 'vuex'
import _debounce from 'lodash.debounce'
import {UploadFile} from '@/helpers/upload-file'

export default {
  name: 'linkView',
  data () {
    return {
      loading: false,
      showNewElement: false,
      document:{
        name: '',
        description: '',
        id: '',
        link: '',
        type: '',
        elements: []
      },
      newElement: {
        tag: '',
        attributes: {
          id: '',
          css: []
        }
      }
    }
  },
  computed: {
    validLink() {
      if(!this.document.link) return false
      return !!this.document.link.match(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/)
    }
  },
  methods: {
    ...mapActions([
      'document/get',
      'document/updateLink',
      'document/destroyLink',
      'document/updateNode',
      'document/destroyNode'
    ]),
    getLink () {
      this.loading = true

      this['document/get']({
        accountId: this.$route.params.account_id,
        id: this.$route.params.linkId,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.document = Object.assign(this.document, res.resource)
        }
      })
    },
    updateDebounce: _debounce(function () {
      if(!this.validLink) return this.$message.warning('Enlace URL no válido')
      this.updateDocument()
    }, 1000, { leading: false, trailing: true }),
    updateDocument() {
      this.loading = true

      this['document/updateLink']({
        accountId: this.$route.params.account_id,
        ...this.document,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.clearNewElement()
        }
      })
    },
    confirmDestroy () {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar enlace? No se puede deshacer.`, {
        title: `Eliminar enlace`,
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          this.destroyLink()
        }
      })
    },
    destroyLink() {
      this.loading = true

      this['document/destroyLink']({
        accountId: this.$route.params.account_id,
        id: this.$route.params.linkId,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.$router.push({name: 'links'}).catch()
        }
      })
    },
    createElement() {
      const element = JSON.parse(JSON.stringify(this.newElement))
      element.attributes.css = element.attributes.css.join()
      this.document.elements.push(element)
      this.updateDocument()
    },
    clearNewElement() {
      this.showNewElement = false
      this.newElement.tag = ''
      this.newElement.attributes.id = ''
      this.newElement.attributes.css = []
    },
    updateNode: _debounce(function (node) {
      this.loading = true

      this['document/updateNode']({
        ...node,
        callback: res => {
          this.loading = false
          if (res.error) this.$message.error(res.error)
        }
      })
    }, 1000, { leading: false, trailing: true }),
    destroyNode (nodeId) {
      this.$bvModal.msgBoxConfirm('¿Deseas eliminar contenido? No se puede deshacer.', {
        title: 'Eliminar contenido',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (!value) return

        this.loading = true

        this['document/destroyNode']({
          accountId: this.$route.params.account_id,
          id: nodeId,
          callback: res => {
            this.loading = false
            if (res.error) return this.$message.error(res.error)
            const index = this.document.nodes.findIndex(el => el.id === nodeId)
            if(index >= 0) {
              this.document.nodes.splice(index, 1)
            }
          }
        })
      })
    }
  },
  mounted () {
    this.getLink()
  },
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>